import {ReduceStore} from 'flux/utils';
import Dispatcher from '../dispatcher';
import ACTION_TYPES from '../constants/action_types';
import { InfoPopupActions } from '../constants/info_popup/info_popup_actions';
import { noop } from '../../../lib/utilities';

class InfoPopupStoreClass extends ReduceStore {
    getInitialState() {
        return {
            visible: false,
            headerContent: '',
            bodyContent: [],
            bodyButtonText: 'Ok, got it!',
            bodyUpperImagePath: '',
            bodyLowerImagePath: '',
            bodyButtonOnClick: noop,
            onCloseClick: noop,
            dispatcher: '',
            showCloseButton: false,
        };
    }

    reduce(state, {source, action}) {
        if (source === ACTION_TYPES.INFO_POPUP_ACTION) {
            switch (action.type) {
                case InfoPopupActions.SHOW:
                    if (!state.visible) {
                        state.visible = true;
                        this.__emitChange();
                    }

                    break;

                case InfoPopupActions.HIDE:
                    if (state.visible) {
                        state.visible = false;
                        state.showCloseButton = false;
                        this.__emitChange();
                    }

                    break;
                case InfoPopupActions.SET_HEADER_CONTENT:
                    if (state.headerContent !== action.payload) {
                        state.headerContent = action.payload;
                        this.__emitChange();
                    }

                    break;
                case InfoPopupActions.ADD_BODY_CONTENT:
                    if (state.bodyContent.indexOf(action.payload) === -1) {
                        state.bodyContent.push(action.payload);
                        this.__emitChange();
                    }

                    break;
                case InfoPopupActions.SET_BODY_BUTTON_TEXT:
                    if (state.bodyButtonText !== action.payload) {
                        state.bodyButtonText = action.payload;
                        this.__emitChange();
                    }

                    break;
                case InfoPopupActions.SET_BODY_BUTTON_ON_CLICK:
                    if (state.bodyButtonOnClick !== action.payload) {
                        state.bodyButtonOnClick = action.payload;
                        this.__emitChange();
                    }

                    break;
                case InfoPopupActions.SET_HEADER_ON_CLOSE_CLICK:
                    if (state.onCloseClick !== action.payload) {
                        state.onCloseClick = action.payload;
                        this.__emitChange();
                    }

                    break;
                case InfoPopupActions.SET_BODY_UPPER_IMAGE_PATH:
                    if (state.bodyUpperImagePath !== action.payload) {
                        state.bodyUpperImagePath = action.payload;
                        this.__emitChange();
                    }

                    break;
                case InfoPopupActions.SET_BODY_LOWER_IMAGE_PATH:
                    if (state.bodyLowerImagePath !== action.payload) {
                        state.bodyLowerImagePath = action.payload;
                        this.__emitChange();
                    }

                    break;
                case InfoPopupActions.SET_DISPATCHER:
                    if (state.dispatcher !== action.payload) {
                        state.dispatcher = action.payload;
                        this.__emitChange();
                    }

                    break;
                case InfoPopupActions.SHOW_CLOSE_BUTTON:
                    if (state.showCloseButton !== action.payload) {
                        state.showCloseButton = action.payload;
                        this.__emitChange();
                    }

                    break;
            }
        }

        return state;
    }
}

const InfoPopupStore = new InfoPopupStoreClass(Dispatcher);
export { InfoPopupStore };